import React from "react";
import cn from "./helpers/cn";

interface FormGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  component?: React.ElementType;
  row?: boolean;
  children?: React.ReactNode;
}

const FormGroup = React.forwardRef<HTMLDivElement, FormGroupProps>((props, ref) => {
  const {
    className,
    component: Component = "div",
    row = false,
    children,
    ...other
  } = props;

  return (
    <Component
      ref={ref}
      className={cn(
        "flex flex-wrap",
        row ? "flex-row" : "flex-col",
        className
      )}
      {...other}
    >
      {children}
    </Component>
  );
});

FormGroup.displayName = "FormGroup";

export default FormGroup;
